export default __webpack_public_path__ + "static/media/product29.996b352a.png";